import React, { useRef, useEffect, useState } from 'react';
import './navbar.css';
import cogIcon from '../images/cog_header.png'
import SearchBar from '../SearchBar/SearchBar.js'

export default function Navbar({ openCustomizationModal, clickedAddNewBusOrTrain }) {
  const [currentTime, setCurrentTime] = useState('');

useEffect(() => {
    const updateClock = (startTime, endTime) => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'pm' : 'am'}`;
      setCurrentTime(formattedTime);

      // Parse "HH:MMam/pm" into total minutes (24h) for comparison
      const parseTime = (timeStr) => {
        const isPM = timeStr.toLowerCase().includes('pm');
        const [h, m] = timeStr.replace(/am|pm/i, "").split(":").map(Number);
        let hour = h;
        if (isPM && h !== 12) hour = h + 12;
        if (!isPM && h === 12) hour = 0;
        return hour * 60 + m;
      };

      const currentMinutes = hours * 60 + minutes;
      const startMinutes = parseTime(startTime);
      const endMinutes = parseTime(endTime);

      // Handle same-day and overnight ranges
      const isInInterval = startMinutes <= endMinutes
        ? currentMinutes >= startMinutes && currentMinutes < endMinutes  // e.g. "8:00am" - "5:00pm"
        : currentMinutes >= startMinutes || currentMinutes < endMinutes; // e.g. "10:00pm" - "8:00am"

      if (isInInterval) {
        darkenScreen(); // 👈 replace with your function
      }
    };

    updateClock("10:00pm", "8:00am"); // 👈 pass your custom times here

    const intervalId = setInterval(() => updateClock("10:00pm", "8:00am"), 5000);

    return () => clearInterval(intervalId);
  }, []);

  async function darkenScreen() {

  }

  return (
    <>
      <div className='screen-brightness'></div>
      <div className='navbar-container'>
        <div className='navbar-top-half'>
          <div className='navbar-title-container'>
            Choocago!
          </div>
        </div>
        <div className='navbar-bottom-half'>
          <SearchBar clickedAddNewBusOrTrain={clickedAddNewBusOrTrain}/>
          <img src={cogIcon} className='navbar-cog-image' onClick={openCustomizationModal}/>
        </div>
      </div>
    </>
  );
}
